import React, { Component } from 'react'
import moment from 'moment';
import { SingleDatePicker, DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import { connect } from "react-redux";

import getDateFormat from "../../utils/DateFormatRetriever";
import QS from '../../utils/QueryStringRetriever';

import { Select, MenuItem } from "@material-ui/core";

import Icon from '../Icon';
import Button from '../Button';
import CitySearcher from "../NewSearchForm/SearchComponents/CitySearch";
import DestinationSearcher from "../NewSearchForm/SearchComponents/DestinationSearch";
import NumericStepper from "../NumericStepper";
import Modal from "../Modal";

import { setForm } from "../../services/form";

import 'react-dates/lib/css/_datepicker.css';
import './index.scss';

class SearchForm extends Component {
    constructor(props) {
        super(props);

        let searchMode = props.dateMode;
        if (searchMode === '' || typeof searchMode === 'undefined') searchMode = 'singlePickerNights';
        if (searchMode !== 'singlePickerNights' && searchMode !== 'doublePicker' && searchMode !== 'rangePicker' && searchMode !== "doublePickerNights") searchMode = 'singlePickerNights';

        this.state = {
            form: {},
            locations: [],
            focusedTwo: false,
            searchMode: searchMode,
            loading: true
        }

        this.searchHandler = this.searchHandler.bind(this);
    }

    componentDidMount() {
        // inicialización del formulario
        let form = {
            ...this.props.form.lodging,
            arrivalDate: moment.utc(this.props.form.lodging.arrivalDate),
            departureDate: moment.utc(this.props.form.lodging.arrivalDate).add(this.props.form.lodging.nights, 'days')
        }
        let childAgeForm = false;

        if (QS()){
            let childrenOnQueryString = false;
            Object.keys(QS()).forEach(key => {
              if ((key === "arrivalDate" || key === "arrivaldate" || key === "arrival" || key === "search_date" ) && QS()[key]) {
                  form.arrivalDate = moment.utc(QS()[key])
              }
              if ((key === "departureDate" || key === "departure" || key === "departuredate") && QS()[key]){
                  form.departureDate = moment.utc(QS()[key]);
                  form.nights = moment.duration(form.departureDate.diff(form.arrivalDate)).asDays();
              }
              if ((key === "childs" || key === "childCount" || key === "childcount" || key === "children" || key === "search_childs") && QS()[key]){
                childrenOnQueryString = true;
                form.children = QS()[key];
                if (this.props.config && this.props.config.childrenAgesSelector && form.children > 0){
                    if (!form.childrenAges && !QS().childrenAges){
                        form.childrenAges = [];
                    } else {
                        childAgeForm = true;
                    }
                }
              }
              if (key === "childrenAges"){
                  if (this.props.config && this.props.config.childrenAgesSelector){
                    if (QS().childrenAges.toString().indexOf(",") > -1){
                        form.childrenAges = QS()[key].split(",");
                        if (!childrenOnQueryString){
                            form.children = QS()[key].split(",").length;
                        }
                    } else {
                        form.childrenAges = [QS()[key]];
                        if (!childrenOnQueryString){
                            form.children = 1;
                        }
                    }
                  }
              }
              if ((key === "adults" || key === "adultCount" || key === "adultcount" || key === "search_adults") && QS()[key]) {
                form.adults = QS()[key];
              } 
              if ((key === "nights" || key === "search_nights" || key === "search_night") && QS()[key]) {
                form.nights = QS()[key]
                form.departureDate = moment.utc(form.arrivalDate).clone().add(form.nights, 'days')
              }
            })
            form.manualSearch = true;
        }

        if ( moment.utc(form.arrivalDate).endOf('day').isBefore(moment.utc().endOf('day')) || form.arrivalDate === "Invalid date" || !moment(form.arrivalDate).isValid() ) { form.arrivalDate = moment.utc().add(2, 'days'); }
        if ( form.departureDate <= form.arrivalDate || form.departureDate === "Invalid date" || !moment(form.departureDate).isValid()) { form.departureDate = form.arrivalDate.clone().add(2, 'days'); }

        // formulario, con las fechas en string, para guardar en redux

        let lodging = {
            ...form, 
            arrivalDate: form.arrivalDate.clone().format("YYYY-MM-DD"),
            departureDate: form.departureDate.clone().format("YYYY-MM-DD")
        }

        // guardamos el formulario en string en redux, y el formato moment en el state
        setForm({ ...this.props.form, lodging }, Object.keys(QS()).length > 0)

        this.setState({ form, loading: false, childAgeForm })
    }

    searchHandler = (afterSelectionChildAges = false) => {
        if (window.innerWidth < 992 && !afterSelectionChildAges && this.props.config && this.props.config.childrenAgesSelector && this.state.form.children > 0){
            this.setState({ childAgeForm: true })
        } else {
            let lodging = {
                ...this.state.form,
                arrivalDate: this.state.form.arrivalDate.clone().format("YYYY-MM-DD"),
                departureDate: this.state.form.departureDate.clone().format("YYYY-MM-DD"),
                manualSearch: true
            }

            setForm({ 
                ...this.props.form, 
                lodging 
            })

            this.props.toggleSearch(false)
            this.props.searchHandler(lodging)
        }
    }

    onChangeGuest = (name, value) => {
        let form = this.state.form;
        let childrenChanged = false;
        if (name === "adults") {
            form.adults = value;
        } else {
            form.children = value;
            if (this.props.config && this.props.config.childrenAgesSelector && form.children > 0){
                let childrenAges = [];
                if (this.state.form.childrenAges){
                    for (let i=0; i<value; i++){
                        if (this.state.form.childrenAges[i]){
                            childrenAges.push(this.state.form.childrenAges[i])
                        }
                    }
                }
                form.childrenAges = childrenAges;
                if (window.innerWidth > 991){
                    childrenChanged = true;
                }
            }
        }

        this.setState({ ...this.state, form: form, childAgeForm: childrenChanged });
    }

    onChangeNights = (name, value) => {
        let form = this.state.form;
        form.nights = value;
        form.departureDate = this.state.form.arrivalDate.clone().add(value, 'days');
        this.setState({ ...this.state, form: form });
    }

    changeCity = ( city ) => {
        this.setState({ form: {...this.state.form, city: city } })
    }

    changeDestination = ( destination ) => {
        this.setState({ 
            form: {
                ...this.state.form, 
                destination: {
                    ...this.state.form.destination,
                    name: destination.name,
                    id: destination.id
                } 
            } 
        }, () => {
            this.props.changeDestination(this.state.form.destination);
        })
    }

    updatechildAge = (child, age) => {
        let childrenAges = this.state.form.childrenAges;
        childrenAges[child] = age;

        this.setState({ 
            form: 
            { 
                ...this.state.form,
                childrenAges
            }
        })
    }

    handleRenderPeopleSearch = (mode) => {
        const maxAdults     = (this.props.config && this.props.config.maxAdults)   || 20;
        const maxChildren   = (this.props.config && this.props.config.maxChildren) || 20;
        const maxNights     = (this.props.config && this.props.config.maxNights)   || 15;

        let individualSuffix = 'adult';
        let pluralSuffix = 'adults'
        let val = this.state.form.adults;
        let maxValue = maxAdults;
        let callback = this.onChangeGuest;
        let label = "Adults";
        let minValue = 1;

        if (mode === 'children') {
            minValue = 0;
            individualSuffix = 'child';
            pluralSuffix = 'children';
            val = this.state.form.children;
            maxValue = maxChildren;
            label = "Children";
            if(this.props.config && this.props.config.minChildren) {
                minValue = this.props.config.minChildren;
            }
        }

        if (mode === 'nights') {
            minValue = 1;
            individualSuffix = 'night';
            pluralSuffix = 'nights';
            val = this.state.form.nights;
            maxValue = maxNights;
            callback = this.onChangeNights;
            label = "Nights";
            if(this.props.config && this.props.config.minNights) {
                minValue = this.props.config.minNights;
            }
        }

        if (mode === 'adults') {
            minValue = 1;
            if(this.props.config && this.props.config.minAdults) {
                minValue = this.props.config.minAdults;
            }
        }

        let items = [];

        for (let idx = minValue; idx <= maxValue; idx++) {
            items.push(<MenuItem key={idx} value={idx}>{idx} {idx === 1 ? individualSuffix : pluralSuffix}</MenuItem>)
        }

        let className = "stepperSearchLodging SearchElement";
        if (mode === 'nights') className += " Nights";

        return (
            <div className="DropdownSearchElement">
                <span className="DropdownSearchLabel">{label}</span>
                <Select 
                    IconComponent={props => 
                        <Icon {...props} icon="feather-chevron-down" />
                    } 
                    style={{textAlign: 'center'}} 
                    className={className} 
                    value={val} 
                    name={pluralSuffix} 
                    onChange={(e) => callback(e.target.name, e.target.value)}
                >
                    {items}
                </Select>
            </div>
        )
    }

    getMobileTitle = () => {
        if (this.props.isMobile){
            let sectionName = this.props.section.replace("-", " ");
            sectionName = sectionName.charAt(0).toUpperCase() + sectionName.slice(1);
            if (
                this.state.form.manualSearch &&
                (!this.props.resultCount || this.props.resultCount === 0)
            ){
                return `No results found for ${sectionName}`
            }
            if (this.props.config && this.props.config.searchModal && this.props.config.searchModal.title){
                return this.props.config.searchModal.title
            }
            return `Welcome to ${sectionName}`
        }
        
    }

    getchildAgeModalContent = () => {
        let selects = [];
        for (let i = 1; i <= this.state.form.children; i++){
            if (this.state.form.childrenAges){
                selects.push(
                    <div className="childAgeSelector">
                        <span>Child {i}: </span>
                        <select value={this.state.form.childrenAges[i - 1]} IconComponent={() => <Icon icon="feather-chevron-down" />} style={{textAlign: 'center'}} defaultValue={undefined} onChange={(e) => this.updatechildAge(i - 1, e.target.value)} >
                            <option value={undefined}  disabled>
                                Select child's age
                            </option>
                            {this.getAges()}
                        </select>
                    </div>
                    
                )
            }
        }

        return selects;
    }

    getAges = () => {
        let ages = [];
        for (let i = 0; i < 18; i++){
            ages.push(
                <option value={i}>
                    {i}
                </option>
            )
        }
        return ages;
    }

    setDatesToState = (startDate, endDate) => {
        let form = this.state.form;

        if (endDate) {
            form.departureDate = endDate;
            form.nights = endDate.startOf('day').diff(this.state.form.arrivalDate.startOf('day'), 'days');
        }

        if (startDate){
            form.arrivalDate = startDate;
            if (startDate.isSameOrAfter(this.state.form.departureDate)){
                form.departureDate = startDate.clone().add(form.nights, "days");
            }
            form.nights = form.departureDate.startOf('day').diff(startDate.startOf('day'), 'days')
        }
        
        this.setState({ form, focusedInput: this.state.focusedInput === "startDate" ? "endDate" : null })
    }

    setDatesToStateSingle = (date) => {
        let departureDate = this.state.form.departureDate
        const isafter = date.isAfter(this.state.form.departureDate);
        if(isafter) {
            departureDate = date.clone().add(2, "days");
        }

        this.setState({ form: { ...this.state.form, arrivalDate: date, departureDate, nights: departureDate.startOf('day').diff(date.startOf('day'), 'days') }, focusedTwo: true });
    }


    handleCloseAgeForm = () => {
        this.setState({ childAgeForm: false }, () => {
            if (window.innerWidth < 992){
                this.searchHandler(true);
            }
        })
    }

    render() {
        let dateModeRender = null;
        if (this.state.loading) return null;
        if (this.state.searchMode === 'rangePicker') {
            if (this.props.isMobile){
                dateModeRender = (
                    <React.Fragment>
                        <div className="NightsRange">
                            <div className="DatePicker">
                                <span className="DropdownSearchLabel">Arrival</span>
                                <SingleDatePicker
                                    hideKeyboardShortcutsPanel={true}
                                    withFullScreenPortal={this.props.isMobile ? true : false}
                                    date={this.state.form.arrivalDate}
                                    isOutsideRange={date => date < moment.utc().startOf('day')}
                                    onDateChange={date => this.setState({ form: { ...this.state.form, arrivalDate: date, nights: this.state.form.departureDate.startOf('day').diff(date.startOf('day'), 'days') }, focusedTwo: true })}
                                    focused={this.state.focused}
                                    onFocusChange={({ focused }) => this.setState({ focused })}
                                    id="your_unique_id"
                                    // eslint-disable-next-line
                                    orientation={this.props.isMobile ? "vertical" : "horizontal"}
                                    numberOfMonths={this.props.isMobile ? 3 : 1}
                                    placeholder="Arrival"
                                    readOnly={true}
                                    keepOpenOnDateSelect={false}
                                    initialVisibleMonth={() => moment.utc(this.state.form.departureDate)}
                                    displayFormat={getDateFormat()}
                                    className="DateSelector SearchElement"
                                />
                            </div>
                            <div className="DatePicker">
                                <span className="DropdownSearchLabel">Departure</span>
                                <SingleDatePicker
                                    hideKeyboardShortcutsPanel={true}
                                    withFullScreenPortal={this.props.isMobile ? true : false}
                                    isOutsideRange={date => date < this.state.form.arrivalDate.clone().add(2, 'days')|| date > this.state.form.arrivalDate.clone().add(1, 'years')}
                                    date={this.state.form.departureDate}
                                    onDateChange={date => this.setState({ form: { ...this.state.form, departureDate: date, nights: date.startOf('day').diff(this.state.form.arrivalDate.startOf('day'), 'days') } })}
                                    focused={this.state.focusedTwo}
                                    onFocusChange={({ focused: focusedTwo }) => this.setState({ focusedTwo })}
                                    id="your_unique_id"
                                    // eslint-disable-next-line
                                    orientation={this.props.isMobile ? "vertical" : "horizontal"}
                                    numberOfMonths={this.props.isMobile ? 3 : 1}
                                    placeholder="Departure"
                                    readOnly={true}
                                    keepOpenOnDateSelect={false}
                                    displayFormat={getDateFormat()}
                                    initialVisibleMonth={() => moment.utc(this.state.form.arrivalDate)}
                                    className="DateSelector SearchElement"
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
            } else {
                dateModeRender = (
                    <div className="DRP">
                        <DateRangePicker
                            hideKeyboardShortcutsPanel={true}
                            withFullScreenPortal={this.props.isMobile ? true : false}
                            readOnly={true}
                            startDate={this.state.form.arrivalDate}
                            startDateId="your_unique_start_date_id"
                            endDate={this.state.form.departureDate}
                            endDateId="your_unique_end_date_id"
                            onDatesChange={({ startDate, endDate }) => this.setDatesToState(startDate, endDate)}
                            focusedInput={this.state.focusedInput}
                            onFocusChange={focusedInput => this.setState({ focusedInput })}
                            // eslint-disable-next-line
                            orientation={this.props.isMobile ? "vertical" : "horizontal"}
                            numberOfMonths={this.props.isMobile ? 3 : 1}
                            startDatePlaceholderText="Arrival"
                            endDatePlaceholderText="Departure"
                            displayFormat={getDateFormat()}
                            openDirection={'down'}
                            customInputIcon={<Icon icon="feather-chevron-down" />}
                            inputIconPosition="after"
                        />
                    </div>
                );
            }
        }

        if (this.state.searchMode === 'doublePickerNights') {
            dateModeRender = (
                <React.Fragment>
                    <div className="NightsRange">
                        <div className="DatePicker">
                            <span className="DropdownSearchLabel">Arrival</span>
                            <SingleDatePicker
                                hideKeyboardShortcutsPanel={true}
                                withFullScreenPortal={this.props.isMobile ? true : false}
                                date={this.state.form.arrivalDate}
                                isOutsideRange={date => date < moment.utc().startOf('day')}
                                onDateChange={date => this.setDatesToStateSingle(date)}
                                focused={this.state.focused}
                                onFocusChange={({ focused }) => this.setState({ focused })}
                                id="your_unique_id"
                                // eslint-disable-next-line
                                orientation={this.props.isMobile ? "vertical" : "horizontal"}
                                numberOfMonths={this.props.isMobile ? 3 : 1}
                                placeholder="Arrival"
                                readOnly={true}
                                keepOpenOnDateSelect={false}
                                initialVisibleMonth={() => moment.utc(this.state.form.departureDate)}
                                displayFormat={getDateFormat()}
                                className="DateSelector SearchElement"
                                customInputIcon={<Icon icon="feather-chevron-down" />}
                                inputIconPosition="after"
                            />
                        </div>
                        <div className="DatePicker">
                            <span className="DropdownSearchLabel">Departure</span>
                            <SingleDatePicker
                                hideKeyboardShortcutsPanel={true}
                                withFullScreenPortal={this.props.isMobile ? true : false}
                                isOutsideRange={date => date < this.state.form.arrivalDate.clone().add(1, 'days') || date > this.state.form.arrivalDate.clone().add(1, 'years')}
                                date={this.state.form.departureDate}
                                onDateChange={date => this.setState({ form: { ...this.state.form, departureDate: date, nights: date.startOf('day').diff(this.state.form.arrivalDate.startOf('day'), 'days') } })}
                                focused={this.state.focusedTwo}
                                onFocusChange={({ focused: focusedTwo }) => this.setState({ focusedTwo })}
                                id="your_unique_id"
                                // eslint-disable-next-line
                                orientation={this.props.isMobile ? "vertical" : "horizontal"}
                                numberOfMonths={this.props.isMobile ? 3 : 1}
                                placeholder="Departure"
                                readOnly={true}
                                keepOpenOnDateSelect={false}
                                displayFormat={getDateFormat()}
                                initialVisibleMonth={() => moment.utc(this.state.form.arrivalDate)}
                                className="DateSelector SearchElement"
                                customInputIcon={<Icon icon="feather-chevron-down" />}
                                inputIconPosition="after"
                            />
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        if (this.state.searchMode === 'singlePickerNights') {
            dateModeRender = (
                <div className="DatePicker">
                    <span className="DropdownSearchLabel">Arrival</span>
                    <SingleDatePicker
                        hideKeyboardShortcutsPanel={true}
                        withFullScreenPortal={this.props.isMobile ? true : false}
                        date={this.state.form.arrivalDate}
                        onDateChange={date => this.setState({ form: { ...this.state.form, arrivalDate: date, departureDate: date.clone().add(this.state.form.nights, 'days') } })}
                        focused={this.state.focused}
                        onFocusChange={({ focused }) => this.setState({ focused })}
                        id="your_unique_id"
                        // eslint-disable-next-line
                        orientation={this.props.isMobile ? "vertical" : "horizontal"}
                        numberOfMonths={this.props.isMobile ? 3 : 1}
                        placeholder="Arrival Date"
                        readOnly={true}
                        keepOpenOnDateSelect={false}
                        displayFormat={getDateFormat()}
                        className="DateSelector SearchElement"
                        customInputIcon={<Icon icon="feather-chevron-down" />}
                        inputIconPosition="after"
                    />
                </div>
            );
        }

        if (this.state.searchMode === 'doublePicker') {
            dateModeRender = (
                <React.Fragment>
                    <div style={{ display: "inline-block" }}>
                        <SingleDatePicker
                            hideKeyboardShortcutsPanel={true}
                            withFullScreenPortal={this.props.isMobile ? true : false}
                            date={this.state.form.arrivalDate}
                            isOutsideRange={date => date < moment.utc().startOf('day')}
                            onDateChange={date => this.setState({ form: { ...this.state.form, arrivalDate: date }, focusedTwo: true })}
                            focused={this.state.focused}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            id="your_unique_id"
                            // eslint-disable-next-line
                            orientation={this.props.isMobile ? "vertical" : "horizontal"}
                            numberOfMonths={this.props.isMobile ? 3 : 1}
                            placeholder="Arrival"
                            readOnly={true}
                            keepOpenOnDateSelect={false}
                            initialVisibleMonth={() => moment.utc(this.state.form.departureDate)}
                            displayFormat={getDateFormat()}
                            className="DateSelector SearchElement"
                            customInputIcon={<Icon icon="feather-chevron-down" />}
                            inputIconPosition="after"
                        />
                        <SingleDatePicker
                            hideKeyboardShortcutsPanel={true}
                            withFullScreenPortal={this.props.isMobile ? true : false}
                            isOutsideRange={date => date < this.state.form.arrivalDate || date > this.state.form.arrivalDate.clone().add(1, 'years')}
                            date={this.state.form.departureDate}
                            onDateChange={date => this.setState({ form: { ...this.state.form, departureDate: date } })}
                            focused={this.state.focusedTwo}
                            onFocusChange={({ focused: focusedTwo }) => this.setState({ focusedTwo })}
                            id="your_unique_id"
                            // eslint-disable-next-line
                            orientation={this.props.isMobile ? "vertical" : "horizontal"}
                            numberOfMonths={this.props.isMobile ? 3 : 1}
                            placeholder="Departure"
                            readOnly={true}
                            keepOpenOnDateSelect={false}
                            displayFormat={getDateFormat()}
                            initialVisibleMonth={() => moment.utc(this.state.form.arrivalDate)}
                            className="DateSelector SearchElement"
                            customInputIcon={<Icon icon="feather-chevron-down" />}
                            inputIconPosition="after"
                        />
                    </div>
                </React.Fragment>
            );
        }

        let className = '';
        if(this.props.className) className += this.props.className;
        if(this.props.isMobile){
            if(className.length !== 0) className += ' ';
            className += 'isMobile';
        }

        return (
            <div className={className}>
                <div className="searchForm">
                    {
                        <p className="searchFormTitle">
                            <span className="titleMobile">{this.getMobileTitle()}</span>
                        </p>
                    }
                    {this.state.form.city && this.state.form.city.enabled ? <CitySearcher config={this.props.config} city={this.state.form.city} changeCity={this.changeCity.bind(this)} /> : null}
                    {this.state.form.destination && this.state.form.destination.enabled ? <DestinationSearcher config={this.props.config} destination={this.state.form.destination} changeDestination={this.changeDestination.bind(this)} /> : null}
                    {dateModeRender}
                    {
                        this.props.isMobile && (this.state.searchMode === "doublePickerNights" || this.state.searchMode === "singlePickerNights")?
                        <React.Fragment>
                            <div className="nights"><NumericStepper label={"Nights"} min={1}  value={this.state.form.nights} default={this.state.form.nights} name="nights" whenChange={this.onChangeNights} /></div>
                            <div className="guestsSelector">
                                <div className="guest">
                                    <NumericStepper label={"Adults"} min={1} default={this.state.form.adults} name="adults" whenChange={this.onChangeGuest} />
                                </div>
                                <div className="guest">
                                    <NumericStepper label={"Children"} min={0} default={this.state.form.children} name="children" whenChange={this.onChangeGuest} />
                                </div>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                        {
                            (this.state.searchMode === "doublePickerNights" || this.state.searchMode === "singlePickerNights") && this.handleRenderPeopleSearch('nights')}
                                {this.props.isLodging ?
                                <div className="guestsSelector">
                                    <div className="guest">
                                        {/* <span>Adults</span>
                                        <NumericStepper className="stepperSearchLodging" onlyDropDown={true} default={this.state.form.adults} name="adults" whenChange={this.onChangeGuest} /> */}
                                        {this.handleRenderPeopleSearch('adults')}
                                    </div>
                                    <div className="guest">
                                        {/* <span>Children</span>
                                        <NumericStepper className="stepperSearchLodging" onlyDropDown={true} min={0} default={this.state.form.children} name="children" whenChange={this.onChangeGuest} /> */}
                                        {this.handleRenderPeopleSearch('children')}
                                    </div>
                                </div>
                            : null
                        }
                    </React.Fragment>
                    }
                </div>
                <div className="searchAction">
                {
                    this.props.isMobile ?
                    <div className="bottomSearch">
                        <div className="ButtonWrapper">
                            <Button onClick={this.searchHandler} className="searchButton">Apply search</Button>
                        </div>
                        <div className="closeBtn">
                            <Icon icon={"iw-close"} onClick={()=>this.props.toggleSearch(false)} size={24} className="closemenu" />
                        </div>
                    </div>
                    :
                    <Button loading={this.props.loading} callBack={this.searchHandler} className={'searchButton'}>
                        SEARCH
                    </Button>
                }
                </div>
                <Modal
                    title={"Select child's age"}
                    open={this.state.childAgeForm}
                    disablePortal={true}
                    className="childAgeForm"
                    closeFn={() => this.setState({ childAgeForm: false })}
                    footerContent={
                        <React.Fragment>
                            <Button onClick={() => this.setState({ childAgeForm: false })} className="closeBtn secondary">
                                <span className="closeText">Close</span>
                                <Icon icon={"iw-close"} />
                            </Button>
                            <Button onClick={() => this.handleCloseAgeForm()} className={window.innerWidth < 992 ? "ButtonWrapper" : "primary"}>
                                Save Changes
                            </Button>
                        </React.Fragment>
                    }
                >

                    <span className="titleMobile">Select child's age</span>        
                    {this.getchildAgeModalContent()}
                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return { form: state.form.form }
}

export default connect(mapStateToProps)(SearchForm)
